"use client";
import { Modal, Button, Tabs } from "@basic-components";
import { useToggle } from "@hooks/useToggle";
import { useImperativeHandle, useState,} from "react";
import Icon from '@ant-design/icons'
import * as icons from "@ant-design/icons";

interface SelectIconModalProps {
  selectedIcon?: string;
  onIconSelect?: (iconName: string) => void;
  ref?: React.Ref<{ toggle: () => void }>;
}

type IconStyle = 'outlined' | 'filled';

export const SelectIconModal: React.FC<SelectIconModalProps> = ({
  selectedIcon,
  onIconSelect,
  ref,
}) => {
  const [visible, toggle] = useToggle();
  const [activeTab, setActiveTab] = useState<IconStyle>('outlined');
  const [currentSelectedIcon, setCurrentSelectedIcon] = useState<string>(selectedIcon || '');
  
  useImperativeHandle(ref, () => ({
    toggle,
  }));
  
  const getIconList = (style: IconStyle) => {
    return Object.keys(icons).filter((item) => {
      const icon = (icons as any)[item];
      if (typeof icon !== 'object') return false;
      
      // 根据选择的图标类型进行过滤
      if (style === 'outlined') {
        return item.endsWith('Outlined');
      } else if (style === 'filled') {
        return item.endsWith('Filled');
      }
      return true;
    });
  };
  
  const handleOk = () => {
    if (onIconSelect && currentSelectedIcon) {
      onIconSelect(currentSelectedIcon);
    }
    toggle();
  };

  const handleIconClick = (iconName: string) => {
    setCurrentSelectedIcon(iconName);
  };

  const renderIconList = (style: IconStyle) => {
    const iconList = getIconList(style);
    
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', maxHeight: '400px', overflowY: 'auto' }}>
        {
          iconList.map((item) => {            
            const isSelected = currentSelectedIcon === item;
            return (
              <div 
                key={item} 
                className="flex items-center justify-center p-2"
                style={{ 
                  width: '100px', 
                  height: '100px', 
                  flexDirection: 'column', 
                  border: isSelected ? '2px solid #1890ff' : '1px solid #f0f0f0',
                  margin: '4px',
                  cursor: 'pointer',
                  borderRadius: '4px',
                }}
                onClick={() => handleIconClick(item)}
              >
                <Icon component={(icons as any)[item]} style={{ fontSize: '24px', marginBottom: '4px' }} />
                <div style={{ fontSize: '12px', textAlign: 'center', wordBreak: 'break-all' }}>{item}</div>
              </div>
            );
          })
        }
      </div>
    );
  };

  const tabItems = [
    {
      key: 'outlined',
      label: '线框图标',
      children: renderIconList('outlined'),
    },
    {
      key: 'filled',
      label: '实底图标',
      children: renderIconList('filled'),
    },
  ];

  return (
    <>
      <div className="flex items-center">
        {currentSelectedIcon && (
          <div className="flex items-center justify-center mr-4">
            <Icon component={(icons as any)[currentSelectedIcon]} style={{ fontSize: '18px' }} />
          </div>
        )}
        <Button type="primary" size="small" onClick={toggle}>选择</Button>
      </div>
      <Modal destroyOnHidden open={visible} onCancel={toggle} footer={null} width={720}>
        <Tabs 
          activeKey={activeTab} 
          onChange={(key) => setActiveTab(key as IconStyle)}
          items={tabItems}
        />
        <div className="flex justify-end gap-3" style={{ marginTop: 16 }}>
          <Button onClick={toggle}>取消</Button>
          <Button type="primary" onClick={handleOk}>确定</Button>
        </div>
      </Modal>
    </>
  );
};